<template>
	<c-modal @close="close">

		<h3 class="margin-b-32">Mijn locaties <span>({{lengthOfAddresses}})</span></h3>

        <div class="margin-b-24">
            <c-form-element :icon="true">
                <div class="c-form-element__icon c-form-element__icon--before color-gray-500">
                    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M5 11c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m15.707 8.293-3.395-3.396C18.365 14.543 19 12.846 19 11c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8c1.846 0 3.543-.635 4.897-1.688l3.396 3.395c.195.195.451.293.707.293.256 0 .512-.098.707-.293a.9989.9989 0 0 0 0-1.414" id="search"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#search"/></svg>
                </div>
                <input type="text" name="search" :placeholder="placeholder" v-model="filterInput" />
            </c-form-element>
        </div>

        <div class="c-addressbook">
			<div class="c-addressbook__item" v-for="address in filteredAddressesList" :key="address.id">
				<div class="font-heading margin-b-4 fw-bold">{{address.name ? address.name : client_name}}</div>
				<div class="color-gray-600">
					{{ address.street }} {{address.number}}{{/^\d/.test(address.addition) ? '-' : ''}}{{address.addition}},
					{{ address.zipcode }} {{ address.city }} <br/>
					<a href="#" class="c-addressbook__link color-secondary" @click.prevent="changeAddres(address)">Wijzigen</a> /
					<a href="#" class="c-addressbook__link color-secondary" @click.prevent="deleteAddress(address.id)">verwijderen</a> 
				</div>
			</div>
		</div>
	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import CFormElement from '@components/form/Element';

export default {
	components: {
		CModal, CFormElement
	},
	props: {
		addresses: {
			required: true,
			type: Array
		},
		client_name: {
			required: true
		},
        placeholder: {
            type: String,
            default: 'Zoeken op straatnaam en plaatsnaam…'
        },
	},
    data () {
        return {
            filterInput: '',
        }
    },
	computed: {
		lengthOfAddresses() {
			return this.addresses.length;
		},
        filteredAddressesList() {
            const value = this.filterInput.toLowerCase().slice(1);
            return this.addresses.filter(function(address){
                return address.street.toLowerCase().indexOf(value) > -1 ||
                    address.city.toLowerCase().indexOf(value) > -1
            })
        }
	},
	methods: {
		close() {
			this.$emit('close');
		},
		deleteAddress(id){
			this.$emit('delete', id);
		},
		changeAddres(address){
			this.$emit('change', address);

		}
    }
}
</script>
